// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Y6vv","large":"styles_large__1Pqqu"};